export default __webpack_public_path__ + "static/media/DiSC_Profile.550cf576.png";